import * as AvatarPrimitive from '@radix-ui/react-avatar';

import { cn } from '../../lib/cn';
import { initialsOf } from '../../lib/format';

const SIZES = {
  xs: 'size-6 text-2xs',
  sm: 'size-8 text-xs',
  md: 'size-10 text-sm',
  lg: 'size-14 text-base',
  xl: 'size-20 text-xl',
  '2xl': 'size-28 text-3xl',
} as const;

export interface AvatarProps {
  src?: string | null;
  name: string;
  size?: keyof typeof SIZES;
  className?: string;
  /** Adds a contrasting ring; used where avatars overlap artwork or each other. */
  ring?: boolean;
}

export function Avatar({ src, name, size = 'md', className, ring = false }: AvatarProps) {
  return (
    <AvatarPrimitive.Root
      className={cn(
        'bg-surface-overlay relative inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full align-middle select-none',
        ring && 'ring-canvas ring-2',
        SIZES[size],
        className,
      )}
    >
      {src ? <AvatarPrimitive.Image src={src} alt="" className="size-full object-cover" /> : null}
      <AvatarPrimitive.Fallback
        className="bg-brand text-text-inverted flex size-full items-center justify-center font-semibold"
        delayMs={src ? 300 : 0}
      >
        {initialsOf(name)}
      </AvatarPrimitive.Fallback>
    </AvatarPrimitive.Root>
  );
}
